// extracted by mini-css-extract-plugin
export default {"document":"Documents_document__XdPwf"};